import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=fb5cf364&scoped=true&"
import script from "./Purchases.vue?vue&type=script&lang=ts&"
export * from "./Purchases.vue?vue&type=script&lang=ts&"
import style0 from "./Purchases.vue?vue&type=style&index=0&id=fb5cf364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5cf364",
  null
  
)

export default component.exports